export default {
  VITE_AUTH_API_URL: import.meta.env.VITE_AUTH_API_URL,
  VITE_API_URL: import.meta.env.VITE_API_URL,
  VITE_WS_API_URL: import.meta.env.VITE_WS_API_URL,
  VITE_AUTHORITY: import.meta.env.VITE_AUTHORITY,
  VITE_CLIENT_ID: import.meta.env.VITE_CLIENT_ID,
  VITE_REDIRECT_URI: import.meta.env.VITE_REDIRECT_URI,
  VITE_POST_LOGOUT_REDIRECT_URI: import.meta.env.VITE_POST_LOGOUT_REDIRECT_URI,
  VITE_SCOPE: import.meta.env.VITE_SCOPE,
  VITE_GOOGLE_MAP_API_KEY: import.meta.env.VITE_GOOGLE_MAP_API_KEY,
  VITE_MUI_LICENSE: import.meta.env.VITE_MUI_LICENSE,
};
